import { ColDef } from 'ag-grid-community';

const commonColDef: ColDef = {
  // デフォルトがfalseの値を変更
  sortable: true,
  resizable: true,
  filter: true,
  // Excelエクスポートでstyleを当てるためにクラス名をつける
  // headerは何も設定しなくても「id: 'header'」を指定すればstyleが当てられるが、
  // cellはclassを設定しないと「id: 'cell'」に反応しない
  cellClass: 'cell',
};

export default commonColDef;
